import { __awaiter } from "tslib";
import { RcsbAnnotationConstants } from "../../../../RcsbAnnotationConfig/RcsbAnnotationConstants";
import { FeatureTools } from "../../../../RcsbCollectTools/FeatureTools/FeatureTools";
export class AnnotationsTrackTitleFactory {
    getTrackTitle(trackManager) {
        return __awaiter(this, void 0, void 0, function* () {
            const c = trackManager.getConfig();
            return c ? buildRowTitle(c) : trackManager.getId();
        });
    }
    getTrackTitleFlagColor(trackManager) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const provenance = Array.from((_b = (_a = trackManager.getConfig()) === null || _a === void 0 ? void 0 : _a.provenanceList) !== null && _b !== void 0 ? _b : []);
            if (provenance.length == 1
                &&
                    (provenance[0] === RcsbAnnotationConstants.provenanceName.pdb || provenance[0] === RcsbAnnotationConstants.provenanceName.promotif)) {
                return RcsbAnnotationConstants.provenanceColorCode.rcsbPdb;
            }
            else {
                return RcsbAnnotationConstants.provenanceColorCode.external;
            }
        });
    }
    getTrackTitlePrefix(trackManager) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            return (_b = (_a = trackManager.getConfig()) === null || _a === void 0 ? void 0 : _a.prefix) !== null && _b !== void 0 ? _b : "";
        });
    }
}
function buildRowTitle(annConfig) {
    return annConfig.prefix ? FeatureTools.parseLink(annConfig.title) : annConfig.title;
}
//# sourceMappingURL=AnnotationsTrackTitleFactory.js.map